export const toUpperCase = function(value: string): string {
  return value.toUpperCase();
};

export const slice = function(
  value: string,
  first: number,
  second: number | undefined
) {
  return value.toString().slice(first, second);
};

export const shortenRoomNumbers = function(value: string, length: number = 2) {
  value = value.toString();
  if (/^\d+$/.test(value)) {
    return value.slice(length * -1);
  }
  return value;
};
